<template>
  <div id="page-staff-list">
    <el-form
      class="search-form"
      :inline="true"
      :model="searchForm"
      ref="searchForm"
      label-width="6em"
      :show-message="false"
    >
      <el-row>
        <el-form-item prop="businessLine" label="业务线" required>
          <filter-business-line :value.sync="searchForm.businessLine" required />
        </el-form-item>
        <el-form-item prop="supplierId" label="合作商" required>
          <filter-businessline-partner
            :value.sync="searchForm.supplierId"
            :code.sync="searchForm.supplierCode"
            :name.sync="supplierName"
            :businessLine="searchForm.businessLine"
            required
          />
        </el-form-item>
        <el-form-item prop="regionId" label="Region">
          <filter-businessline-region
            :value.sync="searchForm.regionId"
            :businessLine="searchForm.businessLine"
          />
        </el-form-item>
        <el-form-item prop="name" label="姓名">
          <el-input
            clearable
            v-model="searchForm.name"
            @input="searchForm.name = searchForm.name.replace(/\s+/g, '')"
          />
        </el-form-item>
        <el-form-item prop="accountStatus" label="账号状态">
          <filter-account-status :value.sync="searchForm.accountStatus" />
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="getStaffList(true)" :loading="loadingList"
            >查询</el-button
          >
        </el-form-item>
      </el-row>
    </el-form>
    <el-row class="align-r margin-b-10">
      <el-button
        @click="addStaffTrigger"
        :disabled="!searchForm.supplierCode"
        v-auth="'/api/partner/outside/platform/staff/openUserAccount'"
        >新增员工账号</el-button
      >
    </el-row>
    <el-table stripe v-loading="loadingList" :data="dataList">
      <el-table-column label="合作商">{{ supplierName }}</el-table-column>
      <el-table-column label="姓名/mis" width="220">
        <template slot-scope="scope">
          {{ scope.row.staffName }}/{{ scope.row.misAccount }}
        </template>
      </el-table-column>
      <el-table-column label="Region" width="350">
        <template slot-scope="scoped">
          <div v-if="scoped.row.supplierRegionNames && scoped.row.supplierRegionNames.length">
            <strong>商平台：</strong>
            {{ scoped.row.supplierRegionNames.join('、') }}
          </div>
          <div v-if="scoped.row.molaRegionName">
            <strong>Mola：</strong>
            {{ scoped.row.molaRegionName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="角色" width="350">
        <template slot-scope="scoped">
          <div v-if="scoped.row.uacRoleNames && scoped.row.uacRoleNames.length">
            <strong>商平台：</strong>
            {{ scoped.row.uacRoleNames.join('、') }}
          </div>
          <div v-if="scoped.row.molaRoleNames && scoped.row.molaRoleNames.length">
            <strong>Mola：</strong>
            {{ scoped.row.molaRoleNames.join('、') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="业务线" prop="businessLineName" width="100" />
      <el-table-column label="账号状态" prop="accountStatusDesc" width="100">
        <template slot-scope="scoped">
          <el-popover
            v-if="scoped.row.accountStatus === 2"
            placement="bottom-start"
            title=""
            width="200"
            trigger="hover"
            :content="`失败原因：${scoped.row.openFailReason}`"
          >
            <span slot="reference" class="ui-danger">
              {{ scoped.row.accountStatusDesc }}
            </span>
          </el-popover>
          <template v-else>{{ scoped.row.accountStatusDesc }}</template>
        </template>
      </el-table-column>
      <el-table-column width="160" label="操作">
        <template slot-scope="scoped">
          <el-button type="text" @click="staffDetail(scoped.row)">详情</el-button>
          <el-button
            v-if="1 === scoped.row.accountStatus"
            v-auth="'/api/partner/outside/platform/staff/editAuthority'"
            type="text"
            @click="showAuthConfig(scoped.row)"
            >编辑权限</el-button
          >
          <el-dropdown class="margin-l-10">
            <el-button type="text">更多</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  v-if="2 === scoped.row.accountStatus"
                  v-auth="'/api/partner/outside/platform/staff/reOpenAccount'"
                  type="text"
                  @click="reopenAccount(scoped.row.id)"
                  >重新开通</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  v-if="3 === scoped.row.accountStatus && 1 === scoped.row.workStatus"
                  v-auth="'/api/partner/outside/platform/staff/accountRecover'"
                  type="text"
                  @click="recoverAccount(scoped.row.id)"
                  >恢复账号</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  v-if="1 === scoped.row.accountStatus"
                  v-auth="'/api/partner/outside/platform/staff/accountStopUse'"
                  type="text"
                  @click="blockAccount(scoped.row.id)"
                  >停用账号</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  v-if="1 === scoped.row.accountStatus"
                  v-auth="'/api/partner/outside/platform/staff/quitStaff'"
                  type="text"
                  @click="dimission(scoped.row.id)"
                  >关闭账号</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  v-if="5 === scoped.row.accountStatus"
                  type="text"
                  @click="reCreateAccount(scoped.row)"
                  >再次启用</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button type="text" @click="editLog(scoped.row.id)">编辑记录</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
    <el-dialog
      width="800px"
      :title="editDialogTitle"
      :visible.sync="editDialogVisible"
      @open="openEditDialog"
      @close="updateOptStatus"
      :before-close="beforeCloseEditDialog"
    >
      <el-row>
        <el-col :span="18">
          <el-form :model="addStaffForm" label-position="right" label-width="15em">
            <el-form-item label="手机号" required>
              <common-decode
                v-if="isView"
                :type="DECODE_TYPE.PHONE"
                :value="addStaffForm.phoneMask"
                :token="addStaffForm.phoneToken"
              />
              <el-input
                v-else
                v-model="addStaffForm.phone"
                @input="addStaffForm.phone = addStaffForm.phone.replace(/\s+/g, '')"
                @blur="handleQueryByPhone"
                placeholder="如：13801234567"
                :disabled="isReCreate"
              />
            </el-form-item>
            <el-form-item label="姓名" required>
              <el-input
                v-model="addStaffForm.staffName"
                @input="addStaffForm.staffName = addStaffForm.staffName.replace(/\s+/g, '')"
                placeholder="如：李四"
                :disabled="isView || isReCreate"
              />
            </el-form-item>
            <el-form-item label="姓名拼音" required>
              <el-input
                v-model="addStaffForm.staffNameCode"
                @input="addStaffForm.staffNameCode = addStaffForm.staffNameCode.replace(/\s+/g, '')"
                placeholder="如：lisi"
                :disabled="isView || isReCreate"
              />
            </el-form-item>
            <el-form-item label="身份证号" required>
              <common-decode
                v-if="isView"
                :type="DECODE_TYPE.ID_CARD"
                :value="addStaffForm.cardIdMask"
                :token="addStaffForm.cardIdToken"
              />
              <el-input
                v-else
                v-model="addStaffForm.cardId"
                @input="addStaffForm.cardId = addStaffForm.cardId.replace(/\s+/g, '')"
                placeholder="如：110110199010102345"
                :maxlength="18"
                :disabled="isReCreate"
              />
            </el-form-item>
            <el-form-item label="邮箱(小写)" required>
              <common-decode
                v-if="isView"
                :type="DECODE_TYPE.EMAIL"
                :value="addStaffForm.emailMask"
                :token="addStaffForm.emailToken"
              />
              <el-input
                v-else
                v-model="addStaffForm.email"
                @input="addStaffForm.email = addStaffForm.email.replace(/\s+/g, '')"
                placeholder="如：lisi@163.com"
                :disabled="isReCreate"
              />
            </el-form-item>
            <el-form-item label="账号负责人" required v-if="addStaffForm.businessLine === 2">
              <span slot="label">
                <span>账号负责人</span>
                <el-tooltip
                  v-if="!isView"
                  effect="dark"
                  placement="bottom"
                  content="默认为操作人当前账号的账号负责人（账号负责人为美团正编员工）"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-input v-model="addStaffForm.ownerName" :disabled="true" placeholder="-" />
            </el-form-item>
            <el-form-item label="业务线" required>
              <filter-business-line :value.sync="addStaffForm.businessLine" disabled />
            </el-form-item>
            <el-form-item v-if="isView" label="员工账号">{{
              addStaffForm.misAccount
            }}</el-form-item>
            <el-form-item v-if="isView" label="美团骑行合作商平台绑定城市">{{
              (addStaffForm.supplierRegionNames && addStaffForm.supplierRegionNames.join('，')) ||
                '--'
            }}</el-form-item>
            <el-form-item v-if="isView" label="美团骑行合作商平台绑定角色">{{
              (addStaffForm.supplierRoleNames && addStaffForm.supplierRoleNames.join('，')) || '--'
            }}</el-form-item>
            <el-form-item v-if="isView && addStaffForm.molaRegionNames" label="Mola APP绑定城市">{{
              (addStaffForm.molaRegionNames && addStaffForm.molaRegionNames.join('，')) || '--'
            }}</el-form-item>
            <el-form-item v-if="isView && addStaffForm.molaRoleNames" label="Mola APP绑定角色">{{
              (addStaffForm.molaRoleNames && addStaffForm.molaRoleNames.join('，')) || '--'
            }}</el-form-item>
            <el-form-item
              v-if="isView && searchForm.businessLine === 2 && addStaffForm.warehouseNames"
              label="仓库权限"
              >{{
                (addStaffForm.warehouseNames && addStaffForm.warehouseNames.join('，')) || '--'
              }}</el-form-item
            >
            <el-form-item v-if="isView && addStaffForm.cityCarrierDTO" label="载具">
              {{ cityCarrier }}
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer">
        <el-button
          @click="
            beforeCloseEditDialog(() => {
              $data.editDialogVisible = false
            })
          "
          >取消</el-button
        >
        <el-button v-if="!isView" type="primary" @click="addStaff" :loading="saving"
          >保存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="900px"
      custom-class="edit-auth-dialog"
      :visible.sync="editAuthDialogVisible"
      @close="closeAuthDialog"
    >
      <el-form label-position="top" :model="authForm" class="auth-form">
        <el-tabs v-model="activeTabName">
          <el-tab-pane label="管理职务信息" name="first">
            <el-form-item label="合作商平台-用户角色">
              <el-checkbox-group v-model="authForm.roleAuthority.supplier_system">
                <el-checkbox
                  v-for="item in supplierRoleNames"
                  :key="item.uacRoleId"
                  :label="item.uacRoleId"
                  >{{ item.roleName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="合作商平台-城市权限">
              <el-checkbox
                v-if="authForm.supplierRegionLabel === -1"
                v-model="authForm.isBindingAllRegion"
                >全国</el-checkbox
              >
              <el-checkbox-group v-else v-model="authForm.regionAuthority.supplier_system">
                <el-checkbox
                  v-for="item in supplierRegionNames"
                  :key="item.regionId"
                  :label="item.regionId"
                  >{{ item.regionName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="作业职务信息" name="second" v-if="molaShowFlag.ifShowMolaAppTab">
            <el-form-item label="Mola-用户角色" v-if="molaRoleNames">
              <el-checkbox-group v-model="authForm.roleAuthority.mola_system">
                <el-checkbox
                  v-for="item in molaRoleNames"
                  :key="item.roleId"
                  :label="item.roleId"
                  >{{ item.roleName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="Mola-城市权限（单选）" v-if="molaRegionNames">
              <el-select
                clearable
                filterable
                v-model="authForm.regionAuthority.mola_system"
                @change="handleMolaRegionChange"
              >
                <el-option
                  v-for="item in molaRegionNames"
                  :key="item.regionId"
                  :value="item.regionId"
                  :label="item.regionName"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="仓库"
              v-if="
                searchForm.businessLine === 2 &&
                  molaShowFlag.ifShowWarehouse &&
                  warehouseNames.length
              "
            >
              <el-checkbox-group v-model="authForm.warehouseAuthority.warehouseAuth">
                <el-checkbox
                  v-for="item in warehouseNames"
                  :key="item.storeId"
                  :label="item.storeId"
                  >{{ item.shopName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="载具">
              <el-cascader
                :props="carrierProps()"
                :key="cascaderKey"
                v-model="authForm.carrierId"
                clearable
              />
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer">
        <el-button @click="editAuthDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAuth" :loading="saving">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑记录" :visible.sync="editLogDialogVisible">
      <el-table stripe :data="editLogList">
        <el-table-column label="操作时间" prop="operateTime" width="150" />
        <el-table-column label="操作人" width="150">
          <template slot-scope="scoped"
            >{{ scoped.row.operateName }}（{{ scoped.row.operateStaffMisAccount }}）</template
          >
        </el-table-column>
        <el-table-column label="操作事件" prop="operateEventDetails" />
      </el-table>
      <div slot="footer">
        <el-button @click="editLogDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import decodeByToken from '@/mixins/decodeByToken'
import { removeEmpty, phoneNoReg } from '@/utils/index'
import { DECODE_TYPE } from '@/enums/constant'
import CommonDecode from '@/components/common/CommonDecode.vue'

const staffTpl = {
  staffName: '',
  staffNameCode: '',
  cardId: '',
  phone: '',
  email: '',
  supplierId: '',
  supplierCode: '',
  businessLine: 2,
}
const authFormTpl = {
  staffId: '',
  supplierRegionLabel: '',
  isBindingAllRegion: false,
  roleAuthority: {
    supplier_system: [],
    mola_system: [],
  },
  regionAuthority: {
    supplier_system: [],
    mola_system: '',
  },
  warehouseAuthority: {
    warehouseAuth: [],
  },
  regionId: '',
  carrierId: [],
}
export default {
  mixins: [pagination, decodeByToken],
  components: {
    CommonDecode,
  },
  data() {
    return {
      DECODE_TYPE,
      loadingList: false,
      saving: false,
      isCreate: false,
      isView: false,
      isReopen: false,
      isReCreate: false,
      supplierName: '',
      searchForm: {
        name: '',
        supplierId: '',
        accountStatus: '',
        businessLine: '',
        regionId: '',
        supplierCode: '',
        querySource: 2,
      },
      dataList: [],
      addStaffForm: (() => {
        try {
          return JSON.parse(JSON.stringify(staffTpl))
        } catch (e) {
          return {}
        }
      })(),
      editDialogVisible: false,
      editLogDialogVisible: false,
      editLogList: [],
      authForm: (() => {
        try {
          return JSON.parse(JSON.stringify(authFormTpl))
        } catch (e) {
          return {}
        }
      })(),
      editAuthDialogVisible: false,
      activeTabName: 'first',
      molaShowFlag: {
        ifShowMolaAppTab: false, // 是否显示molaApp tab, 合作联营、经营咨询、代理任意一种
        ifShowWarehouse: false, // 是否显示mola仓库，合作中的联营、代理
      },
      // 商平台绑定的城市
      supplierRegionNames: [],
      // 商平台绑定的角色
      supplierRoleNames: [],
      // mola 绑定的城市
      molaRegionNames: null,
      // mola 绑定的角色
      molaRoleNames: null,
      // mola 绑定的仓库
      warehouseNames: [],
      // 绑定的载具
      carrierData: null,
      cascaderKey: 0,
    }
  },
  computed: {
    cityCarrier() {
      const { carrierBigName, carrierDispatchName } = this.addStaffForm.cityCarrierDTO || {}
      return (
        `${carrierBigName || ''}${carrierDispatchName ? '/' + carrierDispatchName : ''}` || '--'
      )
    },
    editDialogTitle() {
      if (this.isCreate) {
        return '新增员工信息'
      }
      if (this.isReopen) {
        return '重新开通账号'
      }
      if (this.isReCreate) {
        return '再次启用账号'
      }
      return '员工信息详情'
    },
  },
  created() {
    this.initPagination('getStaffList', false)
  },
  methods: {
    // 列表数据
    getStaffList(init = false) {
      if (!this.searchForm.supplierCode || !this.searchForm.businessLine) return
      if (init) this.pageNo = 1
      const params = {
        ...this.searchForm,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.loadingList = true
      this.fetch
        .post('staffQueryStaffList', removeEmpty(params))
        .then(res => {
          this.dataList = res.data || []
          this.totalAmount = res.count || 0
          this.loadingList = false
          this.ifShowMolaAppTabAndStore()
        })
        .catch(() => {
          this.loadingList = false
        })
    },
    // 点击添加用户
    addStaffTrigger() {
      try {
        this.addStaffForm = JSON.parse(JSON.stringify(staffTpl))
      } catch (e) {
        this.addStaffForm = {}
      }
      this.addStaffForm.businessLine = this.searchForm.businessLine
      this.editDialogVisible = true
      this.isCreate = true
    },
    // 根据手机号带出信息
    handleQueryByPhone() {
      if (!phoneNoReg.test(this.addStaffForm.phone)) return
      const params = {
        phone: this.addStaffForm.phone,
        supplierId: this.searchForm.supplierId,
      }
      this.fetch
        .get('queryByPhone', { params })
        .then(res => {
          const { staffName = '', staffNameCode = '', email = '', cardId = '' } = res.data || {}
          staffName && (this.addStaffForm.staffName = staffName)
          staffNameCode && (this.addStaffForm.staffNameCode = staffNameCode)
          email && (this.addStaffForm.email = email)
          cardId && (this.addStaffForm.cardId = cardId)
        })
        .catch(() => {})
    },
    // 添加用户
    addStaff() {
      const params = {
        ...this.addStaffForm,
        supplierId: this.searchForm.supplierId,
        supplierCode: this.searchForm.supplierCode,
        type: this.isReCreate ? 2 : 1,
      }
      delete params.ownerName
      if (JSON.stringify(params).indexOf(':""') > -1) {
        return this.$message.error('请填写必填信息')
      }
      if (!phoneNoReg.test(params.phone)) {
        return this.$message.error('手机号格式不正确！')
      }

      this.saving = true
      this.fetch
        .post(this.isReopen ? 'staffReOpenAccount' : 'staffOpenUserAccount', params)
        .then(() => {
          this.getStaffList()
          this.editDialogVisible = false
          this.saving = false
          this.$message.success(this.isReopen ? '开通成功' : '添加成功')
        })
        .catch(() => {
          this.saving = false
        })
    },
    openEditDialog() {
      if (this.addStaffForm.businessLine === 1 || this.isView) return
      // 获取账号负责人
      this.fetch
        .get('getOperatorAccountOwner')
        .then(res => {
          const { ownerName, ownerMis } = res.data
          this.$set(this.addStaffForm, 'ownerName', ownerName)
          this.$set(this.addStaffForm, 'ownerMis', ownerMis)
        })
        .catch(() => {})
    },
    // 弹窗关闭后，更新操作状态
    updateOptStatus() {
      this.isCreate = false
      this.isView = false
      this.isReopen = false
      this.isReCreate = false
    },
    // 弹窗关闭前提示
    beforeCloseEditDialog(done) {
      if (this.isView || this.isReopen) return done()
      this.$msgbox
        .confirm('取消后将不会保留已填写的内容！', '', {
          type: 'warning',
        })
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    closeAuthDialog() {
      this.warehouseNames = []
      this.activeTabName = 'first'
      try {
        this.authForm = JSON.parse(JSON.stringify(authFormTpl))
      } catch (e) {
        this.authForm = {}
      }
      this.cascaderKey++
    },
    // 编辑记录
    editLog(staffId) {
      const params = {
        staffId,
        supplierId: this.searchForm.supplierId,
        businessLine: this.searchForm.businessLine,
      }
      this.loadingList = true
      this.fetch
        .get('staffOperateLogList', { params })
        .then(res => {
          this.editLogList = res.data || []
          this.editLogDialogVisible = true
          this.loadingList = false
        })
        .catch(() => {
          this.loadingList = false
        })
    },
    // 查看用户
    staffDetail(user) {
      this.isView = true
      try {
        this.addStaffForm = JSON.parse(JSON.stringify(staffTpl))
      } catch (e) {
        this.addStaffForm = {}
      }
      this.loadingList = true
      const params = {
        id: user.id,
        supplierId: user.supplierId,
        businessLine: user.businessLine,
      }
      this.fetch
        .post('staffGetStaffDetail', params)
        .then(res => {
          this.editDialogVisible = true
          this.loadingList = false
          this.addStaffForm = res.data
        })
        .catch(() => {
          this.loadingList = false
        })
    },
    // 重新开通账号
    reopenAccount(staffId) {
      this.isReopen = true
      try {
        this.addStaffForm = JSON.parse(JSON.stringify(staffTpl))
      } catch (e) {
        this.addStaffForm = {}
      }
      this.loadingList = true
      const params = {
        staffId,
        businessLine: this.addStaffForm.businessLine,
      }
      this.fetch
        .get('staffQueryStaffById', { params })
        .then(res => {
          this.editDialogVisible = true
          this.loadingList = false
          this.addStaffForm = {
            ...res.data,
            businessLine: this.addStaffForm.businessLine,
          }

          this.handleDecodeInfo(
            [
              { type: DECODE_TYPE.ID_CARD, key: 'cardId', token: this.addStaffForm.cardIdToken },
              { type: DECODE_TYPE.PHONE, key: 'phone', token: this.addStaffForm.phoneToken },
              { type: DECODE_TYPE.EMAIL, key: 'email', token: this.addStaffForm.emailToken },
            ],
            (key, text) => this.$set(this.addStaffForm, key, text)
          )
        })
        .catch(() => {
          this.loadingList = false
        })
    },
    // 关闭账号
    dimission(staffId) {
      this.$msgbox
        .confirm(
          '操作账号关闭之后，将解除员工与商家的绑定关系，清除员工所有操作权限。请确认是否继续进行该操作？',
          '账号关闭',
          {
            type: 'warning',
          }
        )
        .then(() => {
          this.loadingList = true
          const params = {
            staffId,
            businessLine: this.searchForm.businessLine,
          }
          this.fetch
            .get('staffQuitStaff', { params })
            .then(() => {
              this.loadingList = false
              this.$message.success('操作成功')
              this.getStaffList()
            })
            .catch(() => {
              this.loadingList = false
            })
        })
        .catch(() => {})
    },
    // 账号状态为关闭 -> 再次启用
    reCreateAccount(user) {
      this.isReCreate = true
      try {
        this.addStaffForm = JSON.parse(JSON.stringify(staffTpl))
      } catch (e) {
        this.addStaffForm = {}
      }
      this.loadingList = true
      const params = {
        id: user.id,
        supplierId: user.supplierId,
        businessLine: user.businessLine,
      }
      this.fetch
        .post('staffGetStaffDetail', params)
        .then(res => {
          this.editDialogVisible = true
          this.loadingList = false
          this.addStaffForm = res.data

          this.handleDecodeInfo(
            [
              { type: DECODE_TYPE.ID_CARD, key: 'cardId', token: this.addStaffForm.cardIdToken },
              { type: DECODE_TYPE.PHONE, key: 'phone', token: this.addStaffForm.phoneToken },
              { type: DECODE_TYPE.EMAIL, key: 'email', token: this.addStaffForm.emailToken },
            ],
            (key, text) => this.$set(this.addStaffForm, key, text)
          )
        })
        .catch(() => {
          this.loadingList = false
        })
    },
    // 恢复账号
    recoverAccount(staffId) {
      this.$confirm('恢复账号之后，账号可继续登录系统。请确认是否进行该操作？', '恢复账号', {
        type: 'warning',
      })
        .then(() => {
          this.loadingList = true
          const params = { staffId }
          this.fetch
            .get('staffAccountRecover', { params })
            .then(() => {
              this.loadingList = false
              this.$message.success('申请成功')
              this.getStaffList()
            })
            .catch(() => {
              this.loadingList = false
            })
        })
        .catch(() => {})
    },
    // 停用账号
    blockAccount(staffId) {
      this.$confirm('停用账号之后，账号将不能登录系统。请确认是否进行该操作？', '停用账号', {
        type: 'warning',
      })
        .then(() => {
          this.loadingList = true
          const params = { staffId }
          this.fetch
            .get('staffAccountStopUse', { params })
            .then(() => {
              this.loadingList = false
              this.$message.success('操作成功')
              this.getStaffList()
            })
            .catch(() => {
              this.loadingList = false
            })
        })
        .catch(() => {})
    },
    // 是否展示molaApp Tab或仓库权限
    ifShowMolaAppTabAndStore() {
      const { supplierId, businessLine } = this.searchForm
      const params = {
        supplierId,
        businessLine,
      }
      this.fetch
        .post('ifShowMolaAppTabAndStore', params)
        .then(res => {
          this.molaShowFlag = res.data
        })
        .catch(() => {})
    },
    // 获取仓库
    async getStoreListByRegion(val) {
      if (!val || this.searchForm.businessLine === 1) {
        this.warehouseNames = []
        return
      }
      const params = {
        staffId: this.authForm.staffId,
        regionId: val,
      }
      await this.fetch
        .get('getStoreListByRegion', { params })
        .then(res => {
          this.warehouseNames = (res && res.data) || []
        })
        .catch(() => {})
    },
    // 编辑权限
    showAuthConfig(user) {
      const params = {
        id: user.id,
        supplierId: user.supplierId,
        businessLine: user.businessLine,
      }
      this.loadingList = true
      this.fetch
        .post('staffGetAuthorityList', params)
        .then(async res => {
          const {
            roleAuthority = {},
            regionAuthority = {},
            supplierRegionLabel,
            isBindingAllRegion,
          } = res.data
          this.editAuthDialogVisible = true
          this.loadingList = false
          try {
            this.authForm = JSON.parse(JSON.stringify(authFormTpl))
          } catch (e) {
            this.authForm = {}
          }
          this.authForm.staffId = user.id
          this.authForm.supplierRegionLabel = supplierRegionLabel
          this.authForm.isBindingAllRegion = isBindingAllRegion
          this.supplierRegionNames = regionAuthority.supplier_system || []
          this.supplierRoleNames = roleAuthority.supplier_system || []
          // this.molaRegionNames = regionAuthority.mola_system || []
          // 产品需求调整 @zhangdi23
          // 需要显示【全部】，则mola城市置空
          this.molaRegionNames =
            supplierRegionLabel === -1 ? [] : regionAuthority.supplier_system || []
          this.molaRoleNames = roleAuthority.mola_system
          // 处理选中
          this.supplierRegionNames.forEach(item => {
            if (item.isBinding) {
              this.authForm.regionAuthority.supplier_system.push(item.regionId)
            }
          })
          this.supplierRoleNames.forEach(item => {
            if (item.isBinding) {
              this.authForm.roleAuthority.supplier_system.push(item.uacRoleId)
            }
          })
          this.molaRoleNames &&
            this.molaRoleNames.forEach(item => {
              if (item.isBinding) {
                this.authForm.roleAuthority.mola_system.push(item.roleId)
              }
            })
          // 处理mola region单选选中
          const selectedtMolaRegionNames = regionAuthority.mola_system
          if (selectedtMolaRegionNames) {
            for (let i = 0; i < selectedtMolaRegionNames.length; i++) {
              if (selectedtMolaRegionNames[i].isBinding) {
                const flag = this.molaRegionNames.find(
                  _ => _.regionId === selectedtMolaRegionNames[i].regionId
                )
                flag &&
                  (this.authForm.regionAuthority.mola_system = selectedtMolaRegionNames[i].regionId)
                break
              }
            }
          }
          // 处理仓库选中
          if (
            user.businessLine === 2 &&
            this.authForm.regionAuthority.mola_system &&
            this.molaRegionNames.length &&
            this.molaShowFlag.ifShowMolaAppTab &&
            this.molaShowFlag.ifShowWarehouse
          ) {
            await this.getStoreListByRegion(this.authForm.regionAuthority.mola_system)
            this.warehouseNames.forEach(item => {
              if (item.isBinding) {
                this.authForm.warehouseAuthority.warehouseAuth.push(item.storeId)
              }
            })
          }
          // 处理载具选中
          if (this.authForm.regionAuthority.mola_system && this.molaShowFlag.ifShowMolaAppTab) {
            await this.getBindingCarrier()
            if (this.carrierData && this.carrierData.carrierId) {
              this.$set(this.authForm, 'carrierId', [
                this.carrierData.carrierBigName,
                this.carrierData.carrierId,
              ])
            }
            this.cascaderKey++
          }
        })
        .catch(() => {
          this.loadingList = false
        })
    },
    // 保存权限
    saveAuth() {
      const params = {
        supplierId: this.searchForm.supplierId,
        staffId: this.authForm.staffId,
        businessLine: this.searchForm.businessLine,
        supplierRegionLabel: this.authForm.supplierRegionLabel,
        isBindingAllRegion: this.authForm.isBindingAllRegion,
        roleAuthority: {
          supplier_system: [],
          mola_system: [],
        },
        regionAuthority: {
          supplier_system: [],
          mola_system: [],
        },
        warehouseAuthority: {
          warehouseAuth: [],
        },
        regionId: this.authForm.regionAuthority.mola_system,
        carrierId: [...this.authForm.carrierId].pop(),
      }
      // 商平台绑定的城市
      this.supplierRegionNames.forEach(item => {
        params.regionAuthority.supplier_system.push({
          ...item,
          isBinding: this.authForm.regionAuthority.supplier_system.includes(item.regionId),
        })
      })
      // 商平台绑定的角色
      this.supplierRoleNames.forEach(item => {
        params.roleAuthority.supplier_system.push({
          ...item,
          isBinding: this.authForm.roleAuthority.supplier_system.includes(item.uacRoleId),
        })
      })
      // mola 绑定的城市
      this.molaRegionNames &&
        this.molaRegionNames.forEach(item => {
          params.regionAuthority.mola_system.push({
            ...item,
            isBinding: this.authForm.regionAuthority.mola_system === item.regionId,
          })
        })
      // mola 绑定的角色
      this.molaRoleNames &&
        this.molaRoleNames.forEach(item => {
          params.roleAuthority.mola_system.push({
            ...item,
            isBinding: this.authForm.roleAuthority.mola_system.includes(item.roleId),
          })
        })
      // mola region 绑定的仓库
      params.businessLine === 2 &&
        this.warehouseNames &&
        this.warehouseNames.forEach(item => {
          params.warehouseAuthority.warehouseAuth.push({
            ...item,
            isBinding: this.authForm.warehouseAuthority.warehouseAuth.includes(item.storeId),
          })
        })
      this.saving = true
      this.fetch
        .post('staffEditAuthority', params)
        .then(() => {
          this.saving = false
          this.editAuthDialogVisible = false
          this.$message.success('操作成功')
          this.getStaffList()
        })
        .catch(() => {
          this.saving = false
        })
    },
    // 获取绑定的载具
    async getBindingCarrier() {
      const params = {
        staffId: this.authForm.staffId,
        supplierId: this.searchForm.supplierId,
        businessLine: this.searchForm.businessLine,
      }
      await this.fetch
        .post('getBindingCarrier', params)
        .then(res => {
          this.carrierData = res.data
        })
        .catch(() => {})
    },
    handleMolaRegionChange(val) {
      this.authForm.warehouseAuthority.warehouseAuth = []
      this.getStoreListByRegion(val)
      this.authForm.carrierId = []
      !val && (this.authForm.regionAuthority.mola_system = '')
      this.cascaderKey++
    },
    // 动态获取载具列表
    carrierProps() {
      const _this = this
      return {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node
          if (level > 1 || !_this.authForm.regionAuthority.mola_system) {
            resolve([])
            return
          }
          if (!level) {
            // 获取载具大类
            const params = {
              cityCode: _this.authForm.regionAuthority.mola_system,
            }
            _this.fetch.post('getBigCarrierListByRegion', params).then(res => {
              const nodes = (res.data || []).map(_ => ({
                value: _.carrierBigName,
                label: _.carrierBigName,
              }))
              resolve(nodes)
            })
          } else {
            const params = {
              bizTypeCode: _this.searchForm.businessLine === 2 ? 20 : 10, // 电单车-20 单车-10
              carrierBigName: node.label,
            }
            // 获取载具小类
            _this.fetch.get('getSmallCarrierList', { params }).then(res => {
              const nodes = (res.data || []).map(_ => ({
                value: _.id,
                label: _.carrierDispatchName,
                leaf: true,
              }))
              resolve(nodes)
            })
          }
        },
      }
    },
  },
  watch: {
    'searchForm.supplierCode': {
      handler() {
        this.dataList = []
        this.getStaffList(true)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
.auth-form {
  .el-divider {
    background: #eeeff5;
  }
  .el-form-item__label {
    font-weight: bold;
  }
  .el-radio-group {
    display: block;
  }
  .el-checkbox,
  .el-radio {
    width: 26%;
    line-height: 1.75;
  }
}
.el-dropdown-menu .el-dropdown-menu__item .el-button {
  width: 100%;
}
.el-dialog__header,
.el-dialog__footer {
  border-bottom-width: 0 !important;
  border-top-width: 0 !important;
}
.edit-auth-dialog .el-dialog__body {
  padding-top: 6px;
}
</style>
